import { appTypeUrl } from '../../enums';

export const appStateDefault = {
  apps: appTypeUrl,
  layout: {
    sidebar: {
      openSubSidebar: true
    }
  }
};
